/* Paintly Diamond Painting variant picker.
   Proxies a custom UI to the native variant-selects engine:
   Diamond Shape (radios), Size (select), Frame (select).
   Variant options order: [Diamond Shape, Size, Frame]. */
(function () {
  var SQ = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>';
  var POR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="6" y="3" width="12" height="18" rx="2"/></svg>';
  var LAN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="3" y="6" width="18" height="12" rx="2"/></svg>';

  function fire(el) { if (el) el.dispatchEvent(new Event('change', { bubbles: true })); }

  function init(vs) {
    var ui = vs.querySelector('.pbnvp');
    if (!ui || ui.dataset.wired) return;
    ui.dataset.wired = '1';

    var shapeInputs = [].slice.call(vs.querySelectorAll('input[name="Diamond Shape"]'));
    var sizeSel = vs.querySelector('select[name="options[Size]"]');
    var frameSel = vs.querySelector('select[name="options[Frame]"]');

    var variants = [];
    try { variants = JSON.parse(vs.querySelector('script[type="application/json"]').textContent) || []; } catch (e) {}

    function exists(shape, size, frame) {
      return variants.some(function (v) {
        if (!v || !v.options || v.available === false) return false;
        if (shape != null && v.options[0] !== shape) return false;
        if (size != null && v.options[1] !== size) return false;
        if (frame != null && v.options[2] !== frame) return false;
        return true;
      });
    }
    function curShape() { var r = shapeInputs.filter(function (x) { return x.checked; })[0]; return r ? r.value : null; }

    var dd = ui.querySelector('.pbnvp-dd');
    var ddbtn = ui.querySelector('.pbnvp-ddbtn');
    if (ddbtn && dd) {
      ddbtn.addEventListener('click', function (e) { e.stopPropagation(); dd.classList.toggle('open'); });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) dd.classList.remove('open'); });
    }
    function parseCm(str){ var m=String(str||'').match(/(\d+)\s*x\s*(\d+)/i); return m?{w:+m[1],h:+m[2]}:null; }
    function orientOf(str){ var d=parseCm(str); if(!d) return null; return d.w===d.h?'Square':(d.w>d.h?'Landscape':'Portrait'); }
    var hasShapes = !!ui.querySelector('.pbnvp-shapes');
    /* sort size rows smallest -> biggest by cm area */
    var panel = ui.querySelector('.pbnvp-ddpanel');
    if (panel) {
      var rowsAll = [].slice.call(panel.querySelectorAll('.pbnvp-ddrow'));
      rowsAll.sort(function(a,b){
        function area(r){ var da=+r.getAttribute('data-area'); if(da) return da; var d=parseCm(r.getAttribute('data-size')); return d?d.w*d.h:0; }
        function wid(r){ var d=parseCm(r.getAttribute('data-size')); return d?d.w:0; }
        return (area(a)-area(b)) || (wid(a)-wid(b));
      });
      rowsAll.forEach(function(r){ panel.appendChild(r); });
    }

    ui.addEventListener('click', function (e) {
      if (e.target.closest('.pbnvp-soldout')) return;
      var s = e.target.closest('[data-ds]');
      if (s) {
        var sv = s.getAttribute('data-ds');
        shapeInputs.forEach(function (r) { if (r.value === sv && !r.checked) { r.checked = true; fire(r); } });
        return;
      }
      var row = e.target.closest('[data-size]');
      if (row) {
        if (sizeSel) { sizeSel.value = row.getAttribute('data-size'); fire(sizeSel); }
        if (dd) dd.classList.remove('open');
        return;
      }
      var sh = e.target.closest('[data-shape]');
      if (sh) {
        var S = sh.getAttribute('data-shape');
        var cur = sizeSel ? sizeSel.value : null;
        if (!sizeSel || orientOf(cur) === S) return;
        var pick = null, d = parseCm(cur);
        if (d) { /* prefer the mirrored size */
          var mir = d.h + 'x' + d.w + 'cm';
          if (orientOf(mir) === S) {
            var mr = null; ui.querySelectorAll('[data-size]').forEach(function (r) { if (r.getAttribute('data-size') === mir) mr = r; });
            if (mr && !mr.classList.contains('pbnvp-soldout')) pick = mir;
          }
        }
        if (!pick) {
          var match = [].slice.call(ui.querySelectorAll('[data-size]')).filter(function (r) { return orientOf(r.getAttribute('data-size')) === S; });
          var avail = match.filter(function (r) { return !r.classList.contains('pbnvp-soldout'); });
          var rp = avail[0] || match[0];
          if (rp) pick = rp.getAttribute('data-size');
        }
        if (pick) { sizeSel.value = pick; fire(sizeSel); }
        return;
      }
      var f = e.target.closest('[data-frame]');
      if (f) {
        if (frameSel) { frameSel.value = f.getAttribute('data-frame'); fire(frameSel); }
        return;
      }
    });

    function sync() {
      var cs = curShape();
      var cz = sizeSel ? sizeSel.value : null;
      var cf = frameSel ? frameSel.value : null;

      ui.querySelectorAll('[data-ds]').forEach(function (b) {
        var V = b.getAttribute('data-ds');
        b.setAttribute('aria-pressed', V === cs);
        b.classList.toggle('pbnvp-soldout', !exists(V, cz, cf));
      });

      var selRow = null;
      ui.querySelectorAll('[data-size]').forEach(function (r) {
        var V = r.getAttribute('data-size');
        r.setAttribute('aria-pressed', V === cz);
        r.classList.toggle('pbnvp-soldout', !exists(cs, V, cf));
        if (V === cz) selRow = r;
      });
      var curOri = cz ? orientOf(cz) : null;
      if (hasShapes) {
        ui.querySelectorAll('.pbnvp-shape').forEach(function (b) {
          var S = b.getAttribute('data-shape');
          b.setAttribute('aria-pressed', S === curOri);
          var any = false;
          ui.querySelectorAll('[data-size]').forEach(function (r) { if (orientOf(r.getAttribute('data-size')) === S && !r.classList.contains('pbnvp-soldout')) any = true; });
          b.classList.toggle('pbnvp-soldout', !any);
        });
        ui.querySelectorAll('[data-size]').forEach(function (r) {
          r.classList.toggle('pbnvp-hide', !!curOri && orientOf(r.getAttribute('data-size')) !== curOri);
        });
      }
      if (ddbtn && selRow) {
        var ori = selRow.getAttribute('data-orient');
        ddbtn.querySelector('.pbnvp-ddlabel').innerHTML =
          '<span class="pbnvp-badge ' + (ori === 'Square' ? 'sq' : (ori === 'Landscape' ? 'lan' : 'por')) + '">' + (ori === 'Square' ? SQ : (ori === 'Landscape' ? LAN : POR)) + ori + '</span>' +
          '<span class="pbnvp-ddsize"><span class="pbnvp-cmv">' + selRow.getAttribute('data-cm') + '</span> <span class="pbnvp-inv">' + selRow.getAttribute('data-in') + '</span></span>';
      }

      ui.querySelectorAll('[data-frame]').forEach(function (b) {
        var V = b.getAttribute('data-frame');
        b.setAttribute('aria-pressed', V === cf);
        b.classList.toggle('pbnvp-soldout', !exists(cs, cz, V));
      });
    }

    vs.addEventListener('change', sync);
    sync();
  }

  function boot() { document.querySelectorAll('variant-selects.pbnvp-host-dp').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
